import { isValid, parseISO } from 'date-fns';
import { baseQuery } from '../baseQuery';
import { ServiceProduct, WithFieldsAsStrings } from 'types';

type ServiceProductResponse = WithFieldsAsStrings<ServiceProduct, 'updatedAt' | 'createdAt' | 'completionDate'>;

function parseDateOrNull(dateString: string | null) {
  const date = parseISO(dateString ?? '');
  return isValid(date) ? date : null;
}

export async function getServiceProducts(serviceId: string | number) {
  const data = await baseQuery(`services/${serviceId}/products`);

  const serviceProducts = (data as ServiceProductResponse[]).map((r) => ({
    ...r,
    createdAt: parseDateOrNull(r.createdAt),
    updatedAt: parseDateOrNull(r.updatedAt),
    completionDate: parseDateOrNull(r.completionDate),
    product: r.product
      ? {
          ...r.product,
          createdAt: parseDateOrNull(r.product.createdAt),
          updatedAt: parseDateOrNull(r.product.updatedAt),
        }
      : null,
  }));

  return serviceProducts.sort((a, b) => a.id - b.id);
}
